<template>
    <div class="account">
        <a-page-header
        style="border: 1px solid rgb(235, 237, 240);background:#fff;padding:16px 32px"
        :breadcrumb="{ props: { routes } }"
        />
        <div class="account-deatil" style="background:#fff;">
            <a-card>
                <div class="search">
                    <a-button type="primary" style="margin-left:14px" @click="addmodal">添加流量来源</a-button>
                </div>

                  <a-table
                    :columns="columns"
       
                    :loading="loading"
                    :data-source="data"
                >
                    <span slot="action" slot-scope="text, record">
                        <a-button type="primary" :size="size"  @click="editshow(index,$event)" :value="record.name" :id="record.id"><a-icon type="edit" />编辑</a-button>
                        <a-button type="danger" :size="size"  @click="delmodal(index,$event)" :id="record.id"><a-icon type="delete" />删除</a-button>
                    </span>
                </a-table>
            </a-card>
        </div>

        <a-modal
        class="pwdmodal"
        title="添加流量来源"
        cancelText="取消"
        okText="确定"
        width="600px"
        :visible="rolemodal"
        :confirm-loading="confirmLoading"
        @ok="addflowtype"
        @cancel="handleCancel"
        >
            <a-row>
                <a-col :span="5">
                    <label class="required-icon">流量来源名称：</label>
                </a-col>
                <a-col :span="16">
                   <a-input  v-model="name" placeholder="请输入流量来源名称"></a-input>
                </a-col>
            </a-row>
            <a-row>
                <a-col :span="5">
                    <label class="required-icon">流量来源标识：</label>
                </a-col>
                <a-col :span="16">
                   <a-input  v-model="code" placeholder="请输入流量来源标识"></a-input>
                </a-col>
            </a-row>
        </a-modal>

        <a-modal
        class="pwdmodal"
        title="编辑流量来源"
        cancelText="取消"
        okText="确定"
        width="600px"
        :visible="editmodal"
        :confirm-loading="confirmLoading"
        @ok="editfolwsource"
        @cancel="handleCancel"
        >
            <a-row>
                <a-col :span="5">
                    <label class="required-icon">流量来源名称：</label>
                </a-col>
                <a-col :span="16">
                   <a-input  v-model="editname" placeholder="请输入流量来源名称"></a-input>
                </a-col>
            </a-row>
            <a-row>
                <a-col :span="5">
                    <label class="required-icon">流量来源标识：</label>
                </a-col>
                <a-col :span="16">
                   <a-input  v-model="editcode" placeholder="请输入流量来源标识"></a-input>
                </a-col>
            </a-row>
        </a-modal>
    </div>
</template>
    
<script>
import { Modal } from 'ant-design-vue';
const columns = [
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
  },
  {
    title: '流量来源名称',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: '操作',
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' },
  },
];

export default {
    data(){
        return{
            routes: [
                {path:'home/main',breadcrumbName: '首页'},
                {breadcrumbName: '流量类型'}
            ],
            data:"",
            columns,
            pagination:{},
            loading:false,
            id:"",
            rolemodal:false,
            editmodal:false,
            confirmLoading:false,
            name:"",
            code:"",
            size:"small",
            editname:"",
            editcode:"",
            editid:""
        }
    },
    mounted(){
        this.$axios.get('/api/getflowsource',{
            headers: {
                "appid": this.appSet.appid,
                "appkey": this.appSet.appkey,
                "token":localStorage.getItem('token'),
            }
        }).then((res)=>{
            if(res.data.code==200){
                this.data=res.data.data
            }else if(res.data.code==300){
                this.$router.push({path: '/'})
            }else if(res.data.code==401){

            }else{

            }
        })
    },
    methods:{
        addmodal(){
            this.rolemodal=true
        },
        editshow(){
            this.editmodal=true
            var editid=event.currentTarget.id
            var name=event.currentTarget.value
            this.editname=name
            this.editid=editid
        },
        handleCancel(){
            this.rolemodal=false
            this.editmodal=false
        },
        // 编辑
        editfolwsource(){
            var params=new URLSearchParams()
            params.append('name',this.editname)
            params.append('code',this.editcode)
            this.$axios.post('/api/editflowsource',params,{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.rolemodal=false,
                    this.$message.success('添加成功');
                    this.$axios.get('/api/getflowsource',{
                        headers: {
                            "appid": this.appSet.appid,
                            "appkey": this.appSet.appkey,
                            "token":localStorage.getItem('token'),
                        }
                    }).then((res)=>{
                        if(res.data.code==200){
                            this.data=res.data.data
                        }else if(res.data.code==300){
                            this.$router.push({path: '/'})
                        }else if(res.data.code==401){

                        }else{

                        }
                    })
                    
                }else if(res.data.code==300){
                    this.$router.push({path: '/'})
                }else if(res.data.code==401){

                }else{

                }
            })
        },

        // 删除
        delmodal(index,event){
            var editid=event.currentTarget.id
        
            Modal.confirm({
                title: '提示',
                content: '您确定删除此流量来源吗?',
                okText: '确定',
                okType: 'danger',
                cancelText: '取消',
                onOk:() => {
                    this.handok(editid)
                },
                onCancel() {

                },
            });
        },

        handok(editid){
            var params=new URLSearchParams()
            params.append('id',editid)
            this.$axios.post('/api/delflowsource',params,{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                }  
            }).then((res)=>{
                if(res.data.code==200){
                    this.$message.success('删除成功');
                    this.$axios.get('/api/getflowsource',{
                        headers: {
                            "appid": this.appSet.appid,
                            "appkey": this.appSet.appkey,
                            "token":localStorage.getItem('token'),
                        }
                    }).then((res)=>{
                        if(res.data.code==200){
                            this.data=res.data.data
                        }else if(res.data.code==300){
                            this.$router.push({path: '/'})
                        }else if(res.data.code==401){
                            this.$message.warning('您暂无此权限');
                        }else{

                        }
                    })
                }else{
                    this.$message.success(res.data.msg);
                }
            })
        },


        // 添加流量来源
        addflowtype(){
            var params=new URLSearchParams()
            params.append('name',this.name)
            params.append('code',this.code)
            this.$axios.post('/api/addflowsource',params,{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.rolemodal=false,
                    this.$message.success('添加成功');
                    this.$axios.get('/api/getflowsource',{
                        headers: {
                            "appid": this.appSet.appid,
                            "appkey": this.appSet.appkey,
                            "token":localStorage.getItem('token'),
                        }
                    }).then((res)=>{
                        if(res.data.code==200){
                            this.data=res.data.data
                            this.rolemodal=false
                            this.$axios.get('/api/getflowsource',{
                                headers: {
                                    "appid": this.appSet.appid,
                                    "appkey": this.appSet.appkey,
                                    "token":localStorage.getItem('token'),
                                }
                            }).then((res)=>{
                                if(res.data.code==200){
                                    this.data=res.data.data
                                }else if(res.data.code==300){
                                    this.$router.push({path: '/'})
                                }else if(res.data.code==401){

                                }else{

                                }
                            })

                        }else if(res.data.code==300){
                            this.$router.push({path: '/'})
                        }else if(res.data.code==401){

                        }else{

                        }
                    })
                    
                }else if(res.data.code==300){
                    this.$router.push({path: '/'})
                }else if(res.data.code==401){

                }else{

                }
            })
        }
        
    }
}
</script>



// WEBPACK FOOTER //
// src/components/flow/flowsource.vue